/* eslint-disable unicorn/no-await-expression-member */
import React from 'react';

import {
  EmptyStateError,
  EmptyStateLoading,
  lazyLoad,
} from 'src/core/common/components/LazyLoad';

export const SetupBudgetByDimensionsPage = lazyLoad({
  loader: async () => ({
    default: (
      await import(
        /* webpackChunkName: "SetupBudgetByDimensionsPage" */ './components/SetupBudgetByDimensionsPage'
      )
    ).SetupBudgetByDimensionsPage,
  }),
  loading: <EmptyStateLoading />,
  fallback: (props) => <EmptyStateError {...props} />,
});
